/**
 * The entry point.
 *
 * The stylesheet is imported, not reimplemented: `packages/tokens/src/base.css`
 * is the same file the mockups render with, so a colour changed for a mockup is
 * a colour changed in the app ([D-061](../../../docs/DECISIONS.md#d-061)).
 */

import '@capytalk/tokens/base.css';
import './app.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.js';

const root = document.getElementById('root');
if (root === null) {
  // The one thing index.html promises. Failing loudly beats a blank page.
  throw new Error('#root is missing from the document');
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
